import { pick } from '@utils/pick';
import { FormState } from 'react-hook-form';
import { EquipmentTypeKeepNulls } from '../types';
import { catchAllSingle, checkCustomFields } from './filterDirtyUtils';

export type IAnyDirty = FormState<EquipmentTypeKeepNulls>['dirtyFields'];
type EquipmentEntries = readonly [
  string,
  EquipmentTypeKeepNulls[keyof EquipmentTypeKeepNulls],
];

export type IFilteredEntries = EquipmentEntries | readonly [string, undefined];

export function filterDirtySingle(
  globalValues: EquipmentTypeKeepNulls,
  anyDirty: IAnyDirty | undefined,
): (Partial<EquipmentTypeKeepNulls> & { id: string }) | undefined {
  const idObj = {
    id: globalValues.id,
    ...pick(globalValues, ['tagsId']),
  };
  if (!anyDirty) return undefined;

  const filteredValues = Object.keys(globalValues).map<IFilteredEntries>(
    key => {
      const keyt = key as keyof EquipmentTypeKeepNulls;
      const valuesT = globalValues;
      // Whitelist
      if (keyt === 'id' || keyt === 'tagsId') return [keyt, valuesT[keyt]];

      if (keyt === 'customFields') {
        return checkCustomFields(keyt, valuesT, anyDirty);
      }
      // unit fields
      const l = catchAllSingle(keyt, valuesT, anyDirty);
      return l;
    },
  );
  const withoutUndef = filteredValues.filter(value => value[1] !== undefined);
  const obj = Object.assign(Object.fromEntries(withoutUndef), idObj);
  return obj;
}
